// externals
import type { Reducer } from 'redux';

// libraries
import type { VehicleReservation } from '@makemydeal/dr-platform-types';
import { initActionTypes } from '@makemydeal/dr-shared-store';

// consts/enums
import { CLEAR_RESERVATION } from '../actionTypes/reservationActionTypes';

export const INITIAL_RESERVATION_STATE: Partial<VehicleReservation> = {};

export type ReservationReducer = Reducer<Partial<VehicleReservation> | null>;

export const reducer: ReservationReducer = (state: Partial<VehicleReservation> | null = INITIAL_RESERVATION_STATE, action: any) => {
    switch (action.type) {
        case initActionTypes.INIT_PENCIL_SUCCESS: {
            return {
                ...state,
                ...(action.payload.reservation || {})
            };
        }
        case CLEAR_RESERVATION: {
            return null;
        }
        default: {
            return state;
        }
    }
};
